<template>
  <div class="cookies-content">
    <h1 class="cookies-title">Slapukų politika</h1>
    
    <section class="cookies-section">
      <h2 class="cookies-section-title">1. Kas yra slapukai?</h2>
      <p>Slapukai yra maži tekstiniai failai, kurie saugomi jūsų įrenginyje (kompiuteryje, planšetėje ar mobiliajame telefone) lankantis svetainėje.</p>
    </section>

    <section class="cookies-section">
      <h2 class="cookies-section-title">2. Kokius slapukus naudojame?</h2>
      
      <div class="cookies-type">
        <h3 class="cookies-type-title">Būtini slapukai</h3>
        <p>Šie slapukai būtini svetainės veikimui. Jie užtikrina pagrindines funkcijas ir saugumą. Be šių slapukų svetainė negali tinkamai veikti.</p>
        <ul>
          <li>Sesijos valdymas</li>
          <li>Saugumo funkcijos</li>
          <li>Slapukų sutikimo valdymas</li>
        </ul>
      </div>

      <div class="cookies-type">
        <h3 class="cookies-type-title">Trečiųjų šalių slapukai</h3>
        <p>Šie slapukai naudojami trečiųjų šalių paslaugoms (pvz., Google Maps). Jie įkeliami tik su jūsų sutikimu.</p>
        <ul>
          <li><strong>Google Maps:</strong> Naudojamas žemėlapių rodymui. Užkrovus žemėlapį gali būti siunčiamos užklausos į Google serverius.</li>
        </ul>
      </div>
    </section>

    <section class="cookies-section">
      <h2 class="cookies-section-title">3. Slapukų saugojimo trukmė</h2>
      <ul>
        <li><strong>Būtini slapukai:</strong> Saugomi iki sesijos pabaigos arba iki 1 metų</li>
        <li><strong>Trečiųjų šalių slapukai:</strong> Priklauso nuo trečiosios šalies politikos</li>
      </ul>
    </section>

    <section class="cookies-section">
      <h2 class="cookies-section-title">4. Slapukų valdymas</h2>
      <p>Galite bet kada pakeisti savo slapukų pasirinkimus:</p>
      <div class="cookies-actions">
        <button class="cookies-btn" @click="openSettings">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
          <span>Atidaryti slapukų nustatymus</span>
        </button>
      </div>
      <p class="cookies-note">Taip pat galite valdyti slapukus per savo naršyklės nustatymus.</p>
    </section>

    <section class="cookies-section">
      <h2 class="cookies-section-title">5. Susisiekite su mumis</h2>
      <p>Dėl klausimų apie slapukus susisiekite:</p>
      <p>
        <strong>El. paštas:</strong> <a href="mailto:info@arunvilkasa.lt">info@arunvilkasa.lt</a><br>
        <strong>Telefonas:</strong> <a href="tel:+37061692311">+370 616 92311</a>
      </p>
    </section>

    <section class="cookies-section">
      <p class="cookies-updated">Paskutinį kartą atnaujinta: {{ currentYear }} m.</p>
    </section>
  </div>
</template>

<script>
import { openCookieSettings } from '@/utils/consent'

export default {
  name: 'Cookies',
  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  },
  methods: {
    openSettings() {
      openCookieSettings()
    }
  }
}
</script>

<style scoped>
.cookies-content {
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
  font-family: 'Open Sans', sans-serif;
  line-height: 1.7;
  color: #333;
}

.cookies-title {
  font-family: 'Montserrat', sans-serif;
  font-size: 2rem;
  font-weight: 800;
  color: #1a1a1a;
  margin-bottom: 30px;
  padding-bottom: 15px;
  border-bottom: 3px solid #dc3545;
}

.cookies-section {
  margin-bottom: 30px;
}

.cookies-section-title {
  font-family: 'Montserrat', sans-serif;
  font-size: 1.3rem;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 15px;
}

.cookies-type {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  border-left: 4px solid #dc3545;
  margin-bottom: 20px;
}

.cookies-type-title {
  font-family: 'Montserrat', sans-serif;
  font-size: 1.1rem;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 10px;
}

.cookies-content ul {
  padding-left: 25px;
}

.cookies-content li {
  margin-bottom: 8px;
}

.cookies-actions {
  margin: 20px 0;
}

.cookies-btn {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 14px 28px;
  background: linear-gradient(135deg, #dc3545, #ff6b6b);
  color: white;
  border: none;
  border-radius: 50px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(220, 53, 69, 0.3);
}

.cookies-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(220, 53, 69, 0.4);
}

.cookies-btn svg {
  width: 20px;
  height: 20px;
}

.cookies-note {
  font-size: 0.9rem;
  color: #6c757d;
  margin-top: 10px;
}

.cookies-content a {
  color: #dc3545;
  text-decoration: none;
}

.cookies-content a:hover {
  text-decoration: underline;
}

.cookies-updated {
  font-size: 0.9rem;
  color: #6c757d;
  font-style: italic;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #e5e5e5;
}
</style>


